import {Injectable} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {MmBimService} from '../../mm-bim.service';
import {BimModel} from '../../../bim-viewer/src/lib/models/bim.model';
import {BehaviorSubject, Subject} from 'rxjs';
import {BimModelVersion} from '../../../bim-viewer/src/lib/models/bim-model-version.interface';
import {ViewerReadyParams} from '../../../bim-viewer/src/lib/models/ready-params';
import {filter} from 'rxjs/operators';
import {PinService} from "../pin-service/pin-service";


@UntilDestroy()
@Injectable()
export class MmBimViewerService {
  private currentBimModelVersionSubject = new BehaviorSubject<BimModelVersion>(null);
  public currentBimModelVersion$ = this.currentBimModelVersionSubject.asObservable();

  private bimViewerReadParamData: ViewerReadyParams;
  private bimModelReadySubject = new Subject<ViewerReadyParams>();
  public bimModelReady$ = this.bimModelReadySubject.asObservable();

  constructor(private mmBimService: MmBimService, private mmPinService: PinService) {
    this.mmBimService.defaultBimModel$
      .pipe(untilDestroyed(this))
      .subscribe(bimModel => {
        this.handleSelectedBimModel(bimModel);
      });
  }

  public onBimViewerReady($event: ViewerReadyParams): void {
    this.bimViewerReadParamData = $event;
    this.bimViewerReadParamData.viewerService.onModelLoaded$.pipe(untilDestroyed(this), filter(Boolean))
      .subscribe(value => {
        this.bimModelReadySubject.next($event);
      });
    $event.pinService.onPinSelectionChanged.pipe(untilDestroyed(this)).subscribe((selectionChange) => {
      this.mmPinService.selectPin(selectionChange.selection[0]);
    });

  }

  private handleSelectedBimModel(bimModel: BimModel): void {
    const currentBimModelVersion = this.currentBimModelVersionSubject.value;
    if (bimModel && currentBimModelVersion?.bimModelId !== bimModel.id) {
      const activeVersions = bimModel.versions?.filter(x => x?.active);
      const activeVersion = activeVersions[activeVersions?.length - 1];
      this.currentBimModelVersionSubject.next(activeVersion);
    }
  }
}
